import { OrderTime, OrderType } from 'types/checkout'

export const COUNT_ORDER_TIMES = 'COUNT_ORDER_TIMES'
export const countOrderTimesAction = (orderTimes: OrderTime[]) => {
  return {
    type: 'COUNT_ORDER_TIMES',
    payload: orderTimes,
  }
}

export const FETCH_ORDERS = 'FETCH_ORDERS'
export const fetchOrdersAction = (orders: OrderType[]) => {
  return {
    type: 'FETCH_ORDERS',
    payload: orders,
  }
}

export const INIT_CHECKOUT = 'INIT_CHECKOUT'
export const initCheckoutAction = () => {
  return {
    type: 'INIT_CHECKOUT',
    payload: undefined,
  }
}

export const SET_CHECKOUT_UNSUBSCRIBES = 'SET_CHECKOUT_UNSUBSCRIBES'
export const setCheckoutUnsubscribesAction = (unsubscribes: Array<() => void>) => {
  return {
    type: 'SET_CHECKOUT_UNSUBSCRIBES',
    payload: unsubscribes,
  }
}

export const INIT_CHECKOUT_UNSUBSCRIBES = 'INIT_CHECKOUT_UNSUBSCRIBES'
export const initCheckoutUnsubscribeAction = () => {
  return {
    type: 'INIT_CHECKOUT_UNSUBSCRIBES',
    payload: undefined,
  }
}
